// role 7 の所属指定（User.e3_department）のクライアント側ヘルパー — 「部署指定拡張」PJ Ph.1（2026-10）
// 保存形式 = 空欄の無い可変長の文字列配列（最大 50 件）。旧来の「10 枠を '' で埋める」形式は廃止。
// サーバー `rcdr_server/utils/e3Department.js`（normalizeE3Department）と同じ上限・正規化。変更時は両方を同期すること。

export const E3_DEPARTMENT_MAX = 50;

const PATH_SEP = '／';

/**
 * 所属経路 1 件を正規化する（各セグメントの前後空白を除き、空セグメントを詰める）。
 * @param {*} path
 * @returns {string}
 */
export const normalizeE3Path = (path) =>
  typeof path === 'string'
    ? path
        .split(PATH_SEP)
        .map((seg) => seg.trim())
        .filter((seg) => seg !== '')
        .join(PATH_SEP)
    : '';

/**
 * 所属指定の配列から空欄を除き、重複をまとめる（先勝ち・順序維持）。
 * 旧形式（'' 埋め・index キーのオブジェクト）も受け付ける。
 * @param {Array|Object|undefined|null} e3Department
 * @returns {string[]}
 */
export const normalizeE3DepartmentList = (e3Department) => {
  const values = Array.isArray(e3Department)
    ? e3Department
    : e3Department && typeof e3Department === 'object'
      ? Object.values(e3Department)
      : [];
  const result = [];
  const seen = new Set();
  values.forEach((value) => {
    const path = normalizeE3Path(value);
    if (path === '' || seen.has(path)) return;
    seen.add(path);
    result.push(path);
  });
  return result;
};
